import { render, staticRenderFns } from "./notifyList.vue?vue&type=template&id=0f66c0b6&scoped=true&"
import script from "./notifyList.vue?vue&type=script&lang=js&"
export * from "./notifyList.vue?vue&type=script&lang=js&"
import style0 from "./notifyList.vue?vue&type=style&index=0&id=0f66c0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66c0b6",
  null
  
)

export default component.exports